import type { SxProps, Theme } from '@mui/material';

export const alertSx: SxProps<Theme> = {
  width: '100%',
};
